/* Общие части рамки загрузки «Текста» (BotCore.upload: .bcu): волна, таблетки, согласие на права перед загрузкой. */
import type { ReactNode } from 'react';
import { uiText } from '../../../i18n';
import { StudioIcon } from '../../studio/StudioIcon';
import { ToolIcon } from '../../studio/circle/ToolIcon';

/** Волна записи (BC.wave.html): столбики линиями во всю ширину */
export function TextWave({ peaks }: { peaks: number[] }) {
  const width = peaks.length * 4;
  return (
    <svg className="b0" viewBox={`0 0 ${width} 36`} preserveAspectRatio="none" aria-hidden="true">
      {peaks.map((peak, index) => {
        const height = Math.max(1, peak * 16),
          x = index * 4 + 2;
        return <line key={index} x1={x} x2={x} y1={(18 - height).toFixed(1)} y2={(18 + height).toFixed(1)} />;
      })}
    </svg>
  );
}
/** Таблетки под превью: «Заменить · Убрать» */
export function FrameActs({ inputId, disabled, onRemove }: { inputId: string; disabled: boolean; onRemove(): void }) {
  return (
    <div className="bcu-fa">
      <label className={`bcu-pl gl${disabled ? ' off' : ''}`} htmlFor={inputId} role="button" tabIndex={0} aria-disabled={disabled || undefined}>
        <ToolIcon kind="refresh" />
        <span>{uiText('Заменить')}</span>
      </label>
      <button className="bcu-pl gl" type="button" disabled={disabled} onClick={onRemove}>
        <ToolIcon kind="trash" />
        <span>{uiText('Убрать')}</span>
      </button>
    </div>
  );
}
/** Пустая рамка: значок, «Загрузите …», подпись, «Загрузить» и «Записать» / «Снять», строка ограничений (или причина отказа) */
export function FrameEmpty({
  inputId,
  icon,
  title,
  sub,
  note,
  bad,
  disabled,
  capture,
}: {
  inputId: string;
  icon: string;
  title: string;
  sub?: string;
  note: string;
  bad?: boolean;
  disabled: boolean;
  capture?: ReactNode;
}) {
  return (
    <>
      <label className="bcu-hit" htmlFor={inputId} aria-hidden="true" tabIndex={-1} />
      <div className="bcu-e">
        <span className="bcu-ic">
          <StudioIcon kind={icon} />
        </span>
        <b className="bcu-t">{uiText(title)}</b>
        {sub && <span className="bcu-s">{uiText(sub)}</span>}
        <div className="bcu-acts">
          <label className={`bcu-pl pri${disabled ? ' off' : ''}`} htmlFor={inputId} role="button" tabIndex={0} aria-disabled={disabled || undefined}>
            <ToolIcon kind="upload" />
            <span>{uiText('Загрузить')}</span>
          </label>
          {capture}
        </div>
        <small className={`bcu-n${bad ? ' bad' : ''}`} role={bad ? 'alert' : undefined}>
          {uiText(note)}
        </small>
      </div>
    </>
  );
}
export function RightsCap() {
  return (
    <p className="bc-cap">
      <StudioIcon kind="photo" />
      <span>{uiText('Только свои файлы или с согласия владельца')}</span>
    </p>
  );
}
